import { doLogout } from "actions/authAction";
import { BASE_URL } from "./constant";
export const PORTALMENU_GET_PAGE = "PORTALMENU_GET_PAGE";
export const PORTALMENU_GET_LIST_PAGE = "PORTALMENU_GET_LIST_PAGE";
export const PORTAL_ADD_MENU = "PORTAL_ADD_MENU";
export const PORTAL_EDIT_MENU = "PORTAL_EDIT_MENU";
export const PORTAL_DELETE_MENU = "PORTAL_DELETE_MENU";

export const PORTAL_SUBMENU_VIEW = "PORTAL_SUBMENU_VIEW";
export const PORTAL_ADD_SUBMENU_VIEW = "PORTAL_ADD_SUBMENU_VIEW";
export const PORTAL_EDIT_SUBMENU_VIEW = "PORTAL_EDIT_SUBMENU_VIEW";
export const PORTAL_DELETE_SUBMENU_VIEW = "PORTAL_DELETE_SUBMENU_VIEW";

export const PORTAL_VIEW_CONTENT = "PORTAL_VIEW_CONTENT";
export const PORTAL_ADD_VIEW_CONTENT = "PORTAL_ADD_VIEW_CONTENT";
export const PORTAL_EDIT_VIEW_CONTENT = "PORTAL_EDIT_VIEW_CONTENT";
export const PORTAL_DELETE_VIEW_CONTENT = "PORTAL_DELETE_VIEW_CONTENT";

export const PORTAL_VIEW_PRODUCT = "PORTAL_VIEW_PRODUCT";
export const PORTAL_OPTION_JENIS_BARANG = "PORTAL_OPTION_JENIS_BARANG";
export const PORTAL_OPTION_PROVINSI = "PORTAL_OPTION_PROVINSI";
export const PORTAL_OPTION_SUPPLIER = "PORTAL_OPTION_SUPPLIER";

// reduce
const portalMenuGetPageAction = (bool, data, status, message) => {
  return {
    type: PORTALMENU_GET_PAGE,
    isLoad: bool,
    data,
    status,
    message,
  };
};
// menu portal reduce
const portalMenuGetListPageAction = (bool, data, status, message) => {
  return {
    type: PORTALMENU_GET_LIST_PAGE,
    isLoad: bool,
    data,
    status,
    message,
  };
};
export const portalAddMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_ADD_MENU,
    isLoad: bool,
    data,
    status,
    message,
  };
};
export const portalEditMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_EDIT_MENU,
    isLoad: bool,
    data,
    status,
    message,
  };
};
export const portalDeleteMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_DELETE_MENU,
    isLoad: bool,
    data,
    status,
    message,
  };
};

// Submenu portal reduce
const portalSubMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_SUBMENU_VIEW,
    isLoad: bool,
    data,
    status,
    message,
  };
};
export const portalAddSubMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_ADD_SUBMENU_VIEW,
    isLoad: bool,
    data,
    status,
    message,
  };
};

export const portalEditSubMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_EDIT_SUBMENU_VIEW,
    isLoad: bool,
    data,
    status,
    message,
  };
};
export const portalDeleteSubMenuAction = (bool, data, status, message) => {
  return {
    type: PORTAL_DELETE_SUBMENU_VIEW,
    isLoad: bool,
    data,
    status,
    message,
  };
};

const portalViewProductLoading = () => {
  return {
    type: PORTAL_VIEW_PRODUCT + "_LOADING",
    load: true,
  };
};

const portalViewProductError = () => {
  return {
    type: PORTAL_VIEW_PRODUCT + "_ERROR",
    error: true,
  };
};

const portalViewProductSuccess = (payload = null) => {
  return {
    type: PORTAL_VIEW_PRODUCT + "_SUCCESS",
    payload: payload,
  };
};

// content portal reduce
const getViewContent = (bool, data, status, message) => {
  return {
    type: PORTAL_VIEW_CONTENT,
    isLoad: bool,
    data,
    status,
    message,
  };
};
export const AddViewContent = (bool, data, status, message) => {
  return {
    type: PORTAL_ADD_VIEW_CONTENT,
    isLoad: bool,
    data,
    status,
    message,
  };
};

export const EditViewContent = (bool, data, status, message) => {
  return {
    type: PORTAL_EDIT_VIEW_CONTENT,
    isLoad: bool,
    data,
    status,
    message,
  };
};

export const DeleteViewContent = (bool, data, status, message) => {
  return {
    type: PORTAL_DELETE_VIEW_CONTENT,
    isLoad: bool,
    data,
    status,
    message,
  };
};

// action

// list cms

export function portalMenuGetList() {
  return (dispatch) => {
    dispatch(portalMenuGetListPageAction(true, [], false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    // if (token) {
    config = {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    // }
    // else {
    //   throw Error("Authentication error")
    // }
    fetch(BASE_URL + "/portal-menu/list", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          dispatch(portalMenuGetListPageAction(false, data.data, false, ""));
        } else {
          dispatch(portalMenuGetPageAction(false, [], true, data.message));
        }
      })
      .catch((err) => {
        dispatch(
          portalMenuGetPageAction(
            false,
            [],
            true,
            "Error Something when wrong, Please try again."
          )
        );
      });
  };
}

// menu portal cms
export function portalMenuGetPage(data) {
  return (dispatch) => {
    dispatch(portalMenuGetPageAction(true, { data: [] }, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/page", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalMenuGetPageAction(false, value.data, false, ""));
        } else {
          dispatch(
            portalMenuGetPageAction(false, { data: [] }, true, value.message)
          );
        }
      })
      .catch((err) => {
        dispatch(portalMenuGetPageAction(false, { data: [] }, true, err));
      });
  };
}

export function portalAddMenu(data) {
  return (dispatch) => {
    dispatch(portalAddMenuAction(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/add", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalAddMenuAction(false, true, false, ""));
        } else {
          dispatch(portalAddMenuAction(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(portalAddMenuAction(false, false, true, err));
      });
  };
}

export function portalEditMenu(data) {
  return (dispatch) => {
    dispatch(portalEditMenuAction(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/update", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalEditMenuAction(false, true, false, ""));
        } else {
          dispatch(portalEditMenuAction(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(portalEditMenuAction(false, false, true, err));
      });
  };
}

export function portalDeleteMenu(data) {
  return (dispatch) => {
    dispatch(portalDeleteMenuAction(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/delete", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalDeleteMenuAction(false, true, false, ""));
        } else {
          dispatch(portalDeleteMenuAction(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(portalDeleteMenuAction(false, false, true, err));
      });
  };
}

// submenu portal cms

export function portalMenuGetViewSub(data) {
  return (dispatch) => {
    dispatch(portalSubMenuAction(true, [], false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/view", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalSubMenuAction(false, value.data, false, ""));
        } else {
          dispatch(portalSubMenuAction(false, [], true, value.message));
        }
      })
      .catch((err) => {
        dispatch(portalSubMenuAction(false, [], true, err));
      });
  };
}

export function portalAddSubMenu(data) {
  return (dispatch) => {
    dispatch(portalAddSubMenuAction(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/add-submenu", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalAddSubMenuAction(false, true, false, ""));
        } else {
          dispatch(portalAddSubMenuAction(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(portalAddSubMenuAction(false, false, true, err));
      });
  };
}

export function portalEditSubMenu(data) {
  return (dispatch) => {
    dispatch(portalEditSubMenuAction(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/update-submenu", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalEditSubMenuAction(false, true, false, ""));
        } else {
          dispatch(portalEditSubMenuAction(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(portalEditSubMenuAction(false, false, true, err));
      });
  };
}

export function portalDeleteSubMenu(data) {
  return (dispatch) => {
    dispatch(portalDeleteSubMenuAction(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu/delete-submenu", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(portalDeleteSubMenuAction(false, true, false, ""));
        } else {
          dispatch(
            portalDeleteSubMenuAction(false, false, true, value.message)
          );
        }
      })
      .catch((err) => {
        dispatch(portalDeleteSubMenuAction(false, false, true, err));
      });
  };
}

// content portal cms
export function portalGetViewContent(data) {
  return (dispatch) => {
    dispatch(getViewContent(true, "", false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + `portal-menu-content?view=${data}`, config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(getViewContent(false, value.data, false, ""));
        } else {
          dispatch(getViewContent(false, "", true, value.message));
        }
      })
      .catch((err) => {
        dispatch(
          getViewContent(
            false,
            "",
            true,
            "Error Something when wrong, Please try again."
          )
        );
      });
  };
}

export function portalAddViewContent(data) {
  return (dispatch) => {
    dispatch(AddViewContent(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu-content/add", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(AddViewContent(false, true, false, ""));
        } else {
          dispatch(AddViewContent(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(
          AddViewContent(
            false,
            false,
            true,
            "Error Something when wrong, Please try again."
          )
        );
      });
  };
}

export function portalEditViewContent(data) {
  return (dispatch) => {
    dispatch(EditViewContent(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu-content/update", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(EditViewContent(false, true, false, ""));
        } else {
          dispatch(EditViewContent(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(
          EditViewContent(
            false,
            false,
            true,
            "Error Something when wrong, Please try again."
          )
        );
      });
  };
}

export function portalDeleteViewContent(data) {
  return (dispatch) => {
    dispatch(DeleteViewContent(true, false, false, ""));

    let token = localStorage.getItem("tolaut@token") || null;
    let config;
    if (token) {
      config = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
    } else {
      throw Error("Authentication error");
    }
    fetch(BASE_URL + "portal-menu-content/delete", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((value) => {
        if (value.status === 200) {
          dispatch(DeleteViewContent(false, true, false, ""));
        } else {
          dispatch(DeleteViewContent(false, false, true, value.message));
        }
      })
      .catch((err) => {
        dispatch(
          DeleteViewContent(
            false,
            false,
            true,
            "Error Something when wrong, Please try again."
          )
        );
      });
  };
}

export function portalViewProduct(params) {
  return (dispatch) => {
    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    };

    dispatch(portalViewProductLoading());
    fetch(BASE_URL + "portal/commodity", config)
      .then((response) => response.json())
      .then((response) => {
        dispatch(portalViewProductSuccess(response));
      })
      .catch((err) => {
        dispatch(portalViewProductError());
      });
  };
}

// Card Landing Page
export const GET_DATA_CARD_URL = "portal/jumlah-users";
export const GET_DATA_CARD_LOADING = "GET_DATA_CARD_LOADING";
export const GET_DATA_CARD_SUCCESS = "GET_DATA_CARD_SUCCESS";
export const GET_DATA_CARD_ERROR = "GET_DATA_CARD_ERROR";

const getDataCardLoading = (bool) => {
  return {
    type: GET_DATA_CARD_LOADING,
    getDataCardLoading: bool,
  };
};

const getDataCardSuccess = (bool, dataCard) => {
  return {
    type: GET_DATA_CARD_SUCCESS,
    getDataCardSuccess: bool,
    dataCard,
  };
};

const getDataCardError = (bool) => {
  return {
    type: GET_DATA_CARD_ERROR,
    getDataCardError: bool,
  };
};

export function getDataCard() {
  return (dispatch) => {
    dispatch(getDataCardLoading(true));
    dispatch(getDataCardSuccess(false, null));
    dispatch(getDataCardError(false));

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    fetch(BASE_URL + GET_DATA_CARD_URL, config)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        dispatch(getDataCardLoading(false));
        return response;
      })
      .then((response) => response.json())
      .then((response) => {
        dispatch(getDataCardSuccess(true, response.data));
      })
      .catch((err) => {
        dispatch(getDataCardError(true));
      });
  };
}

const optionJenisBarangLoading = () => {
  return {
    type: PORTAL_OPTION_JENIS_BARANG + "_LOADING",
    load: true,
  };
};

const optionJenisBarangError = () => {
  return {
    type: PORTAL_OPTION_JENIS_BARANG + "_ERROR",
    error: true,
  };
};

const optionJenisBarangSuccess = (payload = null) => {
  return {
    type: PORTAL_OPTION_JENIS_BARANG + "_SUCCESS",
    payload: payload,
  };
};

const optionProvinsiLoading = () => {
  return {
    type: PORTAL_OPTION_PROVINSI + "_LOADING",
    load: true,
  };
};

const optionProvinsiError = () => {
  return {
    type: PORTAL_OPTION_PROVINSI + "_ERROR",
    error: true,
  };
};

const optionProvinsiSuccess = (payload = null) => {
  return {
    type: PORTAL_OPTION_PROVINSI + "_SUCCESS",
    payload: payload,
  };
};

const optionSupplierLoading = () => {
  return {
    type: PORTAL_OPTION_SUPPLIER + "_LOADING",
    load: true,
  };
};

const optionSupplierError = () => {
  return {
    type: PORTAL_OPTION_SUPPLIER + "_ERROR",
    error: true,
  };
};

const optionSupplierSuccess = (payload = null) => {
  return {
    type: PORTAL_OPTION_SUPPLIER + "_SUCCESS",
    payload: payload,
  };
};

export function portalOptionJenisBarang() {
  return (dispatch) => {
    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    dispatch(optionJenisBarangLoading());
    fetch(BASE_URL + "portal/jenis-barang", config)
      .then((response) => response.json())
      .then((response) => {
        dispatch(optionJenisBarangSuccess(response));
      })
      .catch((err) => {
        dispatch(optionJenisBarangError());
      });
  };
}

export function portalOptionProvinsi() {
  return (dispatch) => {
    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    dispatch(optionProvinsiLoading());
    fetch(BASE_URL + "portal/options-provinsi", config)
      .then((response) => response.json())
      .then((response) => {
        dispatch(optionProvinsiSuccess(response));
      })
      .catch((err) => {
        dispatch(optionProvinsiError());
      });
  };
}

export function portalOptionSupplier() {
  return (dispatch) => {
    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    };

    dispatch(optionSupplierLoading());
    fetch(BASE_URL + "portal/options-supplier", config)
      .then((response) => response.json())
      .then((response) => {
        dispatch(optionSupplierSuccess(response));
      })
      .catch((err) => {
        dispatch(optionSupplierError());
      });
  };
}
